import React from 'react';
import Relay from 'react-relay';
import Link from 'depop/components/Link';
import { css } from 'glamor';

import { FAMILY_EXTENDED_BOLD } from 'depop/styles/typography';

import UserPicture from 'depop/components/images/UserPicture';
import FollowButton from '../../apps/shops/components/FollowButton';

class UserSummary extends React.Component {
  props: {
    user: Object,
    currentUser: ?Object,
    compact: ?Boolean,
  };

  render() {
    const { user, currentUser, compact } = this.props;
    const pictureSize = compact ? '50px' : '75px';
    const summaryMargin = compact ? '0' : '0 0 24px';

    return (
      <div
        {...css({
          margin: summaryMargin,
          display: 'flex',
          alignItems: 'center',
        })}>
        <div {...css({ width: pictureSize, height: pictureSize })}>
          <Link
            to={{
              pathname: `/${user.username}`,
              state: { userId: user.publicId },
            }}>
            <UserPicture user={user} compact />
          </Link>
        </div>
        <div {...css({ marginLeft: 15 })}>
          <h1
            {...css({
              marginBottom: 8,
              fontSize: 16,
              fontFamily: FAMILY_EXTENDED_BOLD,
            })}>
            <Link
              {...css({ textDecoration: 'none', color: 'inherit' })}
              to={{
                pathname: `/${user.username}`,
                state: { userId: user.publicId },
              }}>
              @{user.username}
            </Link>
          </h1>
          <FollowButton user={user} currentUser={currentUser} />
        </div>
      </div>
    );
  }
}

export default Relay.createContainer(UserSummary, {
  fragments: {
    user: () => Relay.QL`
      fragment on User {
        ${UserPicture.getFragment('user')}
        ${FollowButton.getFragment('user')}
        publicId
        username
      }
    `,
    currentUser: () => Relay.QL`
      fragment on User {
        ${FollowButton.getFragment('currentUser')}
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/components/UserSummary/UserSummary.js